import { LOCALE_META, LOCALES, type Locale } from '@ly360/i18n';
import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { setLocale } from '../i18n.ts';
import { Select } from './Pickers.tsx';

/** Language picker. `onChange` lets a signed-in app also save the choice server-side. */
export function LanguageSelect({
  locales = LOCALES,
  onChange,
  compact = false,
}: {
  locales?: readonly Locale[];
  onChange?: (l: Locale) => void;
  compact?: boolean;
}) {
  const { i18n, t } = useTranslation();
  return (
    <div className={`lang-picker${compact ? ' compact' : ''}`}>
      <Languages size={16} aria-hidden="true" className="lang-icon" />
      <Select
        value={i18n.language}
        onChange={(v) => {
          const l = v as Locale;
          setLocale(l);
          onChange?.(l);
        }}
        triggerClassName="select-pill"
        aria-label={t('settings.language')}
        data-testid="language-select"
        options={locales.map((l) => ({
          value: l,
          label: compact ? l.toUpperCase() : LOCALE_META[l].nativeName,
        }))}
      />
    </div>
  );
}
